<replacement-contracts [opportunity]="opportunity" [countryId]="countryId" [permissions]="permissions"
    [availableContracts]="availableContracts" [showMobileView]="showMobileView" [showPullForward]="showPullForward">
</replacement-contracts>
